import script from "./ViewUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewUser.vue?vue&type=script&setup=true&lang=ts"

import "./ViewUser.vue?vue&type=style&index=0&id=8b45629e&lang=scss"

const __exports__ = script;

export default __exports__